module.exports = __webpack_public_path__ + "static/media/multiu.2acb484c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/multiu.png
// module id = 456
// module chunks = 0